import { useState } from 'react';

function usePriceFilter(initialSelectedFilters) {
  const priceFilter = initialSelectedFilters.find(
    (filter) => filter.uid === 'price.items[]',
  );
  const priceFilterValue =
    priceFilter?.subOptions?.map(({ value }) => value) || [];
  const [priceOptions, setPriceOptions] = useState<string[]>(priceFilterValue);

  const onTogglePrice = (value: string) => {
    const isSelected = priceOptions.some((item) => item === value);
    if (isSelected) {
      setPriceOptions(
        (prevDuration) => prevDuration.filter((item) => item !== value) || [],
      );
    } else {
      setPriceOptions((prevDuration) => [...prevDuration, value]);
    }
  };

  return {
    priceOptions,
    onTogglePrice,
  };
}

export default usePriceFilter;
